module.exports = __webpack_public_path__ + "static/media/9DESA14.45252b2c.jpg";